import { Header, Loader } from '@mairistem/composants';
import _ from 'lodash';

import { formatMonetaire } from '@/utils';

type ResumeProps = {
  loading: boolean;
  total: number;
  header: string;
  totalReste: number | null;
};

const Resume = (props: ResumeProps) => {
  const { header, loading, total, totalReste } = props;

  return (
    <>
      <Header as="h3">
        <Header.Content>{header}</Header.Content>
      </Header>
      {loading ? (
        <Loader active />
      ) : (
        <>
          <Header as="h5">
            <Header.Content>{total <= 1 ? `${total} facture` : `${total} factures`}</Header.Content>
          </Header>
          <Header as="h5" style={{ marginTop: 0 }}>
            <Header.Content style={{ display: 'flex' }}>
              Total :{' '}
              {_.isNil(totalReste) ? (
                <div style={{ position: 'relative', flex: 1 }}>
                  <Loader size="tiny" active />
                </div>
              ) : (
                formatMonetaire(totalReste, 2, true)
              )}
            </Header.Content>
          </Header>
        </>
      )}
    </>
  );
};

export default Resume;
